import {InitLoggerValues} from "./types";

export const DEFAULT_INIT_LOGGER_VALUES: InitLoggerValues = {
    env: 'production',
    login: 'unknown',
    version: 'unknown',
    configs: {},
};